import "./rma.css";
import { Link } from "react-router-dom";
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png";
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import rmaBanner from "../images/rma-banner.jpg";
import rmaStart from "../images/rma-start.png";
import rmaWho from "../images/rma-who.png";
import rmaStarted from "../images/rma-started.png";
import check from "../images/check.png";
import Footer from "./footer";
import AOS from 'aos';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const Rma = () => {
  window.scrollTo(0, 0);

  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [listSections, setListSections] = useState([]);
  const [listSectionsItems, setListSectionsItems] = useState([]);
  const [productInfo, setProductInfo] = useState([]);
  const [businessSections, setBusinessSections] = useState([]);
  const [productText, setProductText] = useState("");
  const [productTextContd, setProductTextContd] = useState("");


                 useEffect( () => {
                       AOS.init({
                            offset: 0,
                            duration: 1000,
                            once: true
                              });
                             }, [])
    

  useEffect(() => {
    client
      .query({
        query: gql`
          query NewQuery {
            pages(first: 100) {
              edges {
                node {
                  mortgages {
                    hero {
                      buttonLink
                      buttonName
                      heading
                      caption
                      image {
                        mediaItemUrl
                      }
                    }
                    heromobile {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                    listSection {
                      heading
                      image {
                        mediaItemUrl
                      }
                      list {
                        item
                      }
                    }
                    productText
                    productTextContd
                    productinfo {
                      heading
                      list {
                        item
                      }
                    }
                    section {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);
        setHeroBanner(result.data.pages.edges[20].node.mortgages.hero);
        setHeroMobile(result.data.pages.edges[20].node.mortgages.heromobile);
        setListSections(result.data.pages.edges[20].node.mortgages.listSection);
        setListSectionsItems(
          result.data.pages.edges[20].node.mortgages.listSection.item,
        );
        setProductInfo(result.data.pages.edges[20].node.mortgages.productinfo);
        setProductText(result.data.pages.edges[20].node.mortgages.productText);
        setProductTextContd(
          result.data.pages.edges[20].node.mortgages.productTextContd,
        );
        setBusinessSections(result.data.pages.edges[20].node.mortgages.section);
      });
  }, []);

  let listSectionsDisplay;
  let productInfoDisplay;
  let heroBannerDisplay;
  let heroMobileBannerDisplay;
  let heroMobileDisplay;
  let businessSectionsDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) => (
      <div className="rma-cover">
        <img className="rma-bg" src={banner.image.mediaItemUrl} />
        <div className="rma-content">
          <div className="rma-txt">
            <h1 className="rma-h1" data-aos="zoom-in" data-aos-delay="200">{banner.heading}</h1>
            <p className="grey-p" data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (heroMobile.length > 0) {
    heroMobileBannerDisplay = heroMobile.map((banner, i) => (
      <div className="rma-cover">
        <img className="rma-bg" src={banner.image.mediaItemUrl} />
        <div className="rma-content">
          <div className="rma-txt">
            <h1 className="rma-h1 " data-aos="zoom-in" data-aos-delay="200">{banner.heading}</h1>
            <p className="grey-p" data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (productInfo.length > 0) {
    productInfoDisplay = productInfo.map((info, i) => (
      <div className="slider-divv-rma">
        <div className="card rma-crd text-start">
          <h5 className="rma-hdr " data-aos="fade-up" data-aos-delay="200">{info.heading} </h5>
          <hr className="btm-bdr-rma" />
          <ol
            className="pt-1 ps-3 icon-white"
            style={{
              listStyleType: "decimal-leading-zero",
              paddingLeft: "20px",
            }}
          >
            {info.list.map((items, i) => (
              <li className="grey-p-rma  pt-4" data-aos="fade-up" data-aos-delay="200">{items.item}</li>
            ))}
          </ol>
        </div>
      </div>
    ));
  }

  if (listSections.length > 0) {
    listSectionsDisplay = listSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5"
        >
          <div className="d-flex d-none d-sm-block justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>

          <div className="pension-div1 pb-5">
            <h3 className="rma-h3 pb-1" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              className="pt-2 custom-square"
              style={{ listStyleType: "square", paddingLeft: "20px" }}
            >
              {section.list.map((items, i) => (
                <li className="grey-p-rma  pt-4" style={{ color: "#3B475A" }} data-aos="fade-up" data-aos-delay="200">
                  {items.item}
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex d-block d-sm-none justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between pb-5"
        >
          <div className="pension-div1 pb-5">
            <h3 className="rma-h3 pb-1" data-aos="fade-up" data-aos-delay="200">{section.heading}</h3>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              className="pt-2 custom-square"
              style={{ listStyleType: "none", paddingLeft: "20px" }}
            >
              {section.list.map((items, i) => (
                <li className="grey-p-rma  pt-4" style={{ color: "#3B475A" }} data-aos="fade-up" data-aos-delay="200">
                  <img className="rma-check" src={check} /> {items.item}
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  if (businessSections.length > 0) {
    businessSectionsDisplay = businessSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>

          <div className="values-rma compact-section">
            <h3 className="h3 rsa-h3" data-aos="fade-up" data-aos-delay="200">{section.heading} </h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <a
              class="open-acc-btn grey-p mt-3"
              href={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
            
            >
              {section.buttonName}{" "}
              <FontAwesomeIcon className="rsa-dwn-arr" icon={faArrowRight} />
            </a>
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="values-rma compact-section">
            <h3 className="h3 rsa-h3" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <a
              class="open-a grey-p mt-3"
              href={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
            
            >
              {section.buttonName}
              <FontAwesomeIcon className="rsa-dwn-arr" icon={faArrowRight} />
            </a>
          </div>

          <div id="rma-img" className="d-flex justify-content-end">
            <img src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  return (
    <>
      <div className="rma-container d-block d-sm-none">
        {heroMobileBannerDisplay}
      </div>

      <div className="rma-container d-none d-sm-block">{heroBannerDisplay}</div>

      <div className="containeer">
        <div
          id="mobile-view"
          className="d-flex justify-space-between pt-5 padding-section-standard-bottom"
        >
          <div className=" width-fifty">
            <h2 className="rma-h2 pb-4"> About Residential Mortgage </h2>
          </div>
          <div className=" width-fifty abt-para">
            <p className="grey-p grey-color">{productText} </p>

            <p className="grey-p grey-color mt-3">{productTextContd} </p>
          </div>
        </div>

        {listSectionsDisplay}
      </div>

      <div className="black-cont-rma">
        <div
          id="mobile-view"
          className="containeer  d-flex justify-content-between "
        >
          <div className="slider-divv-head-rma ">
            <p className="orange-p-rma pb-3">APPLICATION GUIDE</p>
            <h2 className="rma-h2 pb-2" style={{ color: "#FFFFFF" }}>
              How to Apply
            </h2>
            <p className="grey-p-rma ">
              Follow these simple steps to use part of your RSA savings as
              equity for your home.
            </p>
          </div>
          {productInfoDisplay}
        </div>
      </div>

      <div className="containeer">{businessSectionsDisplay}</div>
                    <Footer/>
           <div className='height-prod'> 

              </div>
    </>
  );
};

export default Rma;
